export const NAV_BAR_ICON_SIZE = '20px';
